export const INTERFACE_TYPE_ACTION_OPTIONS = [
    { value: 'API', label: 'API' },
    { value: 'BUTTON', label: 'BUTTON' },
    { value: 'FLOW_PROCESS', label: 'FLOW_PROCESS' },
    { value: 'MENU', label: 'MENU' },
    { value: 'SUBMENU', label: 'SUBMENU' },
    { value: 'CHART_REPORT', label: 'REPORTE GRAFICO' }
];

export const ACTION_TYPE_OPTIONS = [
    { value: 'Redirect', label: 'Redirección' },
    { value: 'form', label: 'Formulario' },
    { value: 'trigger', label: 'Ejecutar' },
    { value: 'download', label: 'Descarga' },
    { value: 'detailsTable', label: 'Detalle' }
];

export const FORM_FIELD_TYPE_OPTIONS = [
    { value: 'text', label: 'Texto' },
    { value: 'textarea', label: 'Area de texto' },
    { value: 'number', label: 'Numero' },
    { value: 'email', label: 'Correo electronico' },
    { value: 'password', label: 'Contrasena' },
    { value: 'date', label: 'Fecha' },
    { value: 'switch', label: 'Switch (Si/No)' },
    { value: 'select', label: 'Selector (opciones fijas)' },
    { value: 'select_trigger', label: 'Selector con ejecucion (opciones fijas)' },
    { value: 'multiple_select', label: 'Selector multiple' },
    { value: 'upload', label: 'Subir archivo' },
    { value: 'photo_capture', label: 'Capturar foto' },
    { value: 'html', label: 'Editor HTML' },
    { value: 'MLEditor', label: 'Texto multi-idioma' },
    { value: 'textArray', label: 'Lista de textos' },
    { value: 'key_value', label: 'Objeto JSON' }
];

export const CHART_TYPE_OPTIONS = [
    { value: 'area', label: 'Area' },
    { value: 'complexColumn', label: 'Columnas' },
    { value: 'simpleColumn', label: 'Columna simple' },
    { value: 'line', label: 'Lineas' },
    { value: 'pie', label: 'Circular(Diagrma tipo torta)' }
];

export const HTTP_METHOD_OPTIONS = [
    { value: 'GET', label: 'GET' },
    { value: 'POST', label: 'POST' },
    { value: 'PUT', label: 'PUT' },
    { value: 'PATCH', label: 'PATCH' },
    { value: 'DELETE', label: 'DELETE' }
];

export const TYPES_API = [
    { value: 'api_integration', label: 'Integración API' }
];

export const SUBTYPES_API = [
    { value: 'rest', label: 'REST' }
];

export const URLS_OPTIONS = [
    { value: 'https://r5ton9113k.execute-api.us-east-1.amazonaws.com/@Stage@/rpa/flow/activate', label: 'Url flow' },
    { value: 'https://r5ton9113k.execute-api.us-east-1.amazonaws.com/@Stage@/rpa/manage', label: 'Url Manager' }
];

export const TABLE_COLUMN_TYPE_OPTIONS = ['string', 'number', 'boolean', 'date'];

export const DEFAULT_TRIGGER = {
    type: 'api_integration',
    subtype: 'rest',
    method: 'POST',
    url: '',
    bodyData: {}
};

export const EMPTY_ACTION = {
    accion: '',
    icon: '',
    color: '',
    type: '',
    config: {},
    form: [],
    trigger: [],
    iconHover: '',
    visible: ''
};

export const INITIAL_INTERFACE_FORM = {
    type_action: '',
    name: '',
    process_action: '',
    name_action: '',
    path: '',
    menu: '',
    order_menu: '',
    icon: '',
    visible: '',
    work_flow_related: '',
    flow_process: [],
    work_flow: '',
    configuration: null
};

export const INITIAL_CHART_FORM = {
    accion: '',
    type: '',
    color: '',
    chart: {
        size: {
            gridColumn: 'span 12',
            gridRow: 'span 12'
        }
    },
    trigger: [DEFAULT_TRIGGER]
};

export const createInitialMenuColumn = (id = 'id') => ({
    id,
    label: '',
    type: 'string',
    filterable: false,
    visible: id !== 'id'
});

export const MOCKCONFIG = {
    table: [
        {
            id: "column1",
            label: "Column 1",
            visible: true,
            width: 180
        },
        {
            id: "column2",
            label: "Column 2",
            visible: true,
            width: 180
        },
        {
            id: "column3",
            label: "Column 4",
            visible: true,
            width: 180
        },
        {
            id: "column5",
            label: "Column 5",
            visible: true,
            width: 180
        },
        {
            id: "column6",
            label: "Column 6",
            visible: true,
            width: 180
        },
        {
            id: "column7",
            label: "Column 7",
            visible: true,
            width: 180
        },
        {
            id: "column8",
            label: "Column 8",
            visible: true,
            width: 180
        },
        {
            id: "column9",
            label: "Column 9",
            visible: true,
            width: 180
        }
    ],
    button: []
};;

